require('../Styles/Index.less'); // To make less compile in webpack.

import { ScrollPageToFirstInvalidElement, ScrollPageToTop, ScrollWindowToTop, ScrollEpiFormToTop, ScrollElementLeft, ScrollElementRight, IsElementScrollable } from './JsUtils/JsUtils';

//(window as any).ScrollPageToTop = ScrollPageToTop;
(window as any).bliwa = {
    scrollPageToTop: ScrollPageToTop,
    scrollPageToFirstInvalidElement: ScrollPageToFirstInvalidElement,
    scrollWindowToTop: ScrollWindowToTop,
    scrollEpiFormToTop: ScrollEpiFormToTop,
    scrollElementLeft: ScrollElementLeft,
    scrollElementRight: ScrollElementRight,
    isElementScrollable: IsElementScrollable,
};


import { CookieTractorCustomEvents } from './CookieTractor/CookieTractorCustomEvents';
import { BlazorCustomHandler } from './Blazor/BlazorCustomHandler';
export { BlazorCustomHandler };

//Sätter eventlyssnare mot Cookie Tractors events för att köra Create Update av egen site-cookie med klinetens medgivande.
//Detta behövs så Cookie Tractor har felaktig encoding på deras JSON-sträng i deras egen cookie.
new CookieTractorCustomEvents();